<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center" id="formWrapper">
        <v-col cols="12" sm="8" md="4">
          <img :src="logoUrl" id="logo" />
          <v-card id="loginCard">
            <v-window v-model="step">
              <v-window-item>
                <v-card-text>
                  <v-container>
                    <v-form
                      name="checkemail"
                      @submit.prevent="checkMail"
                      v-model="checkformValid"
                    >
                      <div>
                        <h2>Du hast dein Kennwort vergessen?</h2>
                        Bitte gib deine Email Adresse ein die du für deinen
                        Account nutzt
                      </div>
                      <v-text-field
                        id="email"
                        label="Email Adresse"
                        name="email"
                        prepend-icon="mdi-email"
                        type="text"
                        v-model="email"
                        :rules="[rules.required, rules.email]"
                      />
                    </v-form>
                  </v-container>
                  <v-container v-if="isMailCheckError">
                    <v-alert type="error" color="red" border="top">
                      Leider ist ein Fehler aufgetreten, deine Email Adresse
                      konnte nicht korrekt überprüft werden!
                    </v-alert>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    block
                    color="secondary"
                    @click="checkMail"
                    name="checkMail"
                    :disabled="!checkformValid"
                    >Email Adresse überprüfen</v-btn
                  >
                </v-card-actions>
              </v-window-item>
              <v-window-item>
                <v-card-text>
                  <v-container>
                    <v-form
                      name="checkCode"
                      @submit.prevent="checkCode"
                      v-model="checkCodeformValid"
                    >
                      <div>
                        <h2>Bestätigunsgscode eingeben</h2>
                        Bitte gib deinen Bestätigungscode ein den du per Email
                        erhalten hast.
                      </div>
                      <v-text-field
                        id="code"
                        label="Bestätigungscode"
                        name="code"
                        prepend-icon="mdi-numeric"
                        type="text"
                        v-model="confirmCode"
                        :rules="[rules.required, rules.eq8]"
                        v-on:keypress="checkCodeInput"
                      />
                    </v-form>
                  </v-container>
                  <v-container v-if="isCodeCheckError">
                    <v-alert type="error" color="red" border="top">
                      Leider ist ein Fehler aufgetreten, dein Bestätigunsgscode
                      stimmt nicht überein.
                    </v-alert>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    block
                    color="secondary"
                    @click="checkCode"
                    name="checkCode"
                    :disabled="!checkCodeformValid"
                    >Code bestätigen</v-btn
                  >
                </v-card-actions>
              </v-window-item>
              <v-window-item>
                <v-card-text>
                  <v-container v-if="!isError && !pwChanged">
                    <v-form
                      name="activateform"
                      @submit.prevent="login"
                      v-model="formValid"
                    >
                      <div>
                        <h2>Hallo {{ user ? user.firstname : "" }}</h2>
                        Um dein Konto zu aktivieren setze dir bitte ein Passwort
                        und bestätige unsere AGBs.
                      </div>
                      <v-text-field
                        id="password"
                        label="Password"
                        name="password"
                        prepend-icon="mdi-lock"
                        :type="passwordVisible1"
                        v-model="password"
                        :rules="[rules.required, rules.min]"
                        :append-icon="passwordIcon1"
                        @click:append="showPassword1"
                      />

                      <v-text-field
                        id="passwordconfirm"
                        label="Password bestätigen"
                        name="passwordconfirm"
                        prepend-icon="mdi-lock"
                        :type="passwordVisible2"
                        v-model="passwordconfirm"
                        :rules="[rules.required, passwordConfirmationRule]"
                        :append-icon="passwordIcon2"
                        @click:append="showPassword2"
                      />
                    </v-form>
                  </v-container>
                  <v-container v-else-if="!isError && pwChanged">
                    <v-alert type="success" color="green" border="top">
                      <p>
                        Vielen Dank!<br />
                        Dein Passwort wurde geändert, du kannst dich jetzt damit
                        anmelden.
                      </p>
                      <div>
                        <a :href="redirectURL" style="color: #fff"
                          >Klicke hier um dich anzumelden</a
                        >
                      </div>
                    </v-alert>
                  </v-container>
                  <v-container v-else>
                    <v-alert type="error" color="red" border="top">
                      Leider ist ein Fehler aufgetreten, das Passwort konnte
                      nicht gespeichert werden.
                    </v-alert>
                  </v-container>
                </v-card-text>
                <v-card-actions v-if="!isError && !pwChanged">
                  <v-spacer />
                  <v-btn
                    block
                    color="success"
                    @click="save"
                    name="submit"
                    type="submit"
                    :disabled="!formValid"
                    >Passwort jetzt ändern</v-btn
                  >
                </v-card-actions>
              </v-window-item>
            </v-window>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import UserService from "@/services/UserService";

export default {
  name: "PwdReset",
  data: () => ({
    passwordVisible1: "password",
    passwordIcon1: "mdi-eye-outline",
    passwordVisible2: "password",
    passwordIcon2: "mdi-eye-outline",
    step: 0,
    email: "",
    confirmCode: "",
    token: null,
    isError: false,
    isMailCheckError: false,
    isCodeCheckError: false,
    pwChanged: false,
    password: "",
    passwordconfirm: "",
    formValid: false,
    checkformValid: false,
    checkCodeformValid: false,
    rules: {
      required: (value) => !!value || "Dieses Feld wird benötigt!.",
      min: (v) => v.length >= 8 || "mind. 8 Zeichen",
      eq8: (v) => v.length == 8 || "Bitte den 8-stelligen Code eingeben",
      email: (v) =>
        /.+@.+/.test(v) ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(v) ||
        "Gib eine gültige Email Adresse an",
    },

    user: null,
  }),

  computed: {
    logoUrl() {
      return `${process.env.VUE_APP_API_URL}/ressources/images/logo.png`;
    },
    redirectURL() {
      return process.env.VUE_APP_FRONTEND_URL;
    },
    passwordConfirmationRule() {
      return () =>
        this.password === this.passwordconfirm ||
        "Die Passwörter stimmen nicht überein";
    },
  },

  methods: {
    showPassword1() {
      if (this.passwordVisible1 === "password") {
        this.passwordVisible1 = "text";
        this.passwordIcon1 = "mdi-eye-off-outline";
      } else {
        this.passwordVisible1 = "password";
        this.passwordIcon1 = "mdi-eye-outline";
      }
    },
    showPassword2() {
      if (this.passwordVisible2 === "password") {
        this.passwordVisible2 = "text";
        this.passwordIcon2 = "mdi-eye-off-outline";
      } else {
        this.passwordVisible2 = "password";
        this.passwordIcon2 = "mdi-eye-outline";
      }
    },
    checkCodeInput(evt) {
      if (this.confirmCode.length >= 8) {
        evt.preventDefault();
        return false;
      }
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
        return false;
      }
      return true;
    },
    checkMail() {
      UserService.pwResetCheckEmail(this.email)
        .then((result) => {
          if (result.data.data.status == "success") {
            this.step++;
          } else {
            this.isMailCheckError = true;
          }
        })
        .catch((error) => {
          this.isMailCheckError = true;
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Aktivierungsfehler",
            text: error,
          });
          return false;
        });
    },
    checkCode() {
      UserService.pwResetCheckCode(this.confirmCode, this.email)
        .then((result) => {
          if (result.data.data && result.data.data.status == "success") {
            this.step++;
          } else {
            this.isCodeCheckError = true;
          }
        })
        .catch((error) => {
          this.isCodeCheckError = true;
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Aktivierungsfehler",
            text: error,
          });
          return false;
        });
    },
    save() {
      if (!this.formValid) {
        this.$notify({
          group: "dataline",
          type: "error",
          title: "Aktivierungsfehler",
          text: "Formular unvollständig",
        });
        return false;
      }
      UserService.pwReset({
        email: this.email,
        code: this.confirmCode,
        password: this.password,
        passwordConfirm: this.passwordconfirm,
      })
        .then((result) => {
          if (result.data.data && result.data.data.status == "success") {
            this.pwChanged = true;
          }

          // this.$router.push("/dashboard");
        })
        .catch((error) => {
          const msg =
            error.response && error.response.data
              ? error.response.data.error
              : error.message;
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Aktivierungsfehler",
            text: msg,
          });
        });
    },
  },
  beforeCreate() {
    this.$store.commit("user/LOGOUT");
  },
  created() {},
};
</script>

<style scoped>
#formWrapper {
  background-color: rgba(255, 255, 255, 0.7);
  padding: 20px 0px 100px 0px;
  margin-top: 100px;
  transform: skewY(-2deg);
  text-align: center;
}
#loginCard {
  transform: skewY(2deg);
}

#logo {
  width: 150px;
  margin-top: -110px;
  margin-bottom: 50px;
}
</style>
